import { NzModalRef, NZ_MODAL_DATA } from 'ng-zorro-antd/modal';
import { Component, OnInit, TemplateRef, Type, inject } from '@angular/core';
import { MONIEPOINT_DESIGN_TYPE } from '../../../shared/constants';

@Component({
	selector: 'app-alert',
	templateUrl: './alert.component.html',
	styleUrls: ['./alert.component.scss'],
})
export class AlertComponent implements OnInit {
	alertType: 'success' | 'confirm' | 'error' | 'warning' | 'delete';
	message: string;
	title: string;
	callback: any;
	callbackName: string;
	declineText = 'moniepoint.decline';
	submitting: boolean;
	designType: MONIEPOINT_DESIGN_TYPE = MONIEPOINT_DESIGN_TYPE.MONIEPOINT_V2;
	readonly MONIEPOINT_DESIGN_TYPE = MONIEPOINT_DESIGN_TYPE;
	cancelName: string;
	cancelCallback: any;
	expiryTime: any;
	ref: Type<any>;
	messageTemplate: TemplateRef<any>;
	time: any;
	cancelText = 'moniepoint.cancel';
	showInfoModalAcceptButton = true;
	isDecline = false;
	readonly nzModalData = inject(NZ_MODAL_DATA, { optional: true }) ?? {};

	constructor(public modal: NzModalRef) {}

	ngOnInit(): void {
		this.modal.componentInstance = {...this.modal.componentInstance, ...this.nzModalData}
		this.alertType = this.modal.componentInstance.alertType;
		this.message = this.modal.componentInstance.message;
		this.title = this.modal.componentInstance.title;
		this.callback = this.modal.componentInstance.callback;
		this.callbackName = this.modal.componentInstance.callbackName;
		this.designType = this.modal.componentInstance.designType;
		this.cancelName = this.modal.componentInstance.cancelName;
		this.cancelCallback = this.modal.componentInstance.cancelCallback;
		this.expiryTime = this.modal.componentInstance.expiryTime;
		this.ref = this.modal.componentInstance.ref;
		this.messageTemplate = this.modal.componentInstance.messageTemplate;
		this.declineText = this.modal?.componentInstance?.declineText || 'moniepoint.decline';
		this.isDecline = this.modal?.componentInstance?.isDecline;
		this.showInfoModalAcceptButton = this.modal?.componentInstance?.showInfoModalAcceptButton ?? true;
	}

	continue() {
		if (this.callback) {
			this.callback();
		}
		this.modal.destroy();
	}

	confirm() {
		this.submitting = true;
		this.callback(true);
	}

	cancel() {
		if (this.cancelCallback) {
			this.cancelCallback();
		}
		this.modal.destroy();
	}

	close() {
		this.callback(false);
		this.modal.destroy();
	}
}
